module.exports = __webpack_public_path__ + "static/media/playline-lobby.2b913640.svg";